import request from '@/utils/request'

// 查询导航
export function navbarList(query) {
    return request({
        url: '/mhportal/navbar/treeData',
        method: 'get',
        params: query
    })
}
// 查询banner列表
export function belowNavigationBar(query) {
    return request({
        url: '/mhportal/slide/belowNavigationBar',
        method: 'get',
        params: query
    })
}
//查询子栏目
export function categoryList(query) {
    return request({
        url: '/mhportal/category/listByPid',
        method: 'post',
        data: query
    })
}

//查询栏目详情
export function categoryInfo(query) {
    return request({
        url: '/mhportal/category/getInfo',
        method: 'get',
        params: query
    })
}

//查询文章列表
export function listByCat(query) {
    return request({
        url: '/mhportal/article/listByCat',
        method: 'post',
        params:{pageSize:query.pageSize,pageNum:query.pageNum},
        data: query
    })
}


//查询搜索列表
export function fuzzyList(query) {
    return request({
        url: '/mhportal/article/fuzzyList',
        method: 'post',
        data: query
    })
}

//查询文章详情
export function getInfo(query) {
    return request({
        url: '/mhportal/article/getInfo',
        method: 'post',
        data: query
    })
}


//供应商登录
export function mhlogin(query) {
    return request({
        url: '/mhportal/mhlogin',
        method: 'post',
        data: query,
        headers: {
            isToken: false,
        },
    })
}

//供应商注册
export function supplierReg(query) {
    return request({
        url: '/mhportal/supplierReg',
        method: 'post',
        data: query
    })
}


//更新供应商信息
export function editSupplierInfo(query) {
    return request({
        url: '/mhportal/editSupplierInfo',
        method: 'post',
        data: query
    })
}

//供应商缴费
export function supplierPay(query) {
    return request({
        url: '/mhportal/supplierPay',
        method: 'post',
        data: query
    })
}

//查询供应商信息
export function myInfo(query) {
    return request({
        url: '/mhportal/myInfo',
        method: 'get',
    })
}


//供应商报名
export function applyTender(query) {
    return request({
        url: '/mhportal/applyTender',
        method: 'post',
        data:{
            articleId:query.articleId,
        }
    })
}



//查询字典
export function getDicts(dictType) {
    return request({
        url: '/mhportal/dictByType?dictType='+dictType,
        method: 'get',
    })
}

//退出登录
export function mhlogout(dictType) {
    return request({
        url: '/mhportal/mhlogout',
        method: 'post',

    })
}


